export const COOKIE_NAME = 'nextjs-example-ai-chat-gpt3'

// default first message to display in UI (not necessary to define the prompt)
export const initialMessages = [
  {
    who: 'bot',
    message:
      'Hi, I’m Relysia AI. I was created to help you with your questions. Please send me your initial queries and I’ll try to give you precise answers. Thanks and good luck!',
  },
]
